export enum TronAssetShortcode {
  USDTTronToken = 'USDT_TRC20',
  USDCTronToken = 'USDC_TRC20',
}

export const TRON_TOKENS = new Set(Object.values(TronAssetShortcode));
